
import axios from "axios";
import _ from "lodash";
import OverlayPanel from 'primevue/overlaypanel';
import moment from "moment";
import store from "@/store";

const CACHE_KEY = 'HeaderSearch_v1_history';

export default {
    name: 'HeaderSearch',

    components: {OverlayPanel},

    props: {
        historyInOverlay: {required: false, default: true},
    },

    data() {
        return {
            isSearching: false,
            isResultFound: false as boolean | null,
            searchQuery: '',
            renewHistory: 0,

            // @ts-ignore
            debouncedSearch: _.debounce(this.search, 500),
            axiosAbortController: new AbortController,
        }
    },

    computed: {
        historyCount() {
            return 5;
        },
        searchHistory(): Record<string, any>[] {
            try {
                this.renewHistory;
                return JSON.parse(localStorage.getItem(CACHE_KEY) ?? '[]').slice(0, this.historyCount)
            } catch (e) {
                console.error(e);
                return []
            }
        },
        componentToShowHistory() {
            return this.historyInOverlay ? OverlayPanel : 'div';
        },
    },

    methods: {
        search(searchQuery: string): void {
            this.axiosAbortController = new AbortController;
            this.isSearching = true;

            axios.get(`/api/rest/frontend/quick-search`, {
                params: {
                    q: searchQuery,
                },
                signal: this.axiosAbortController.signal,
            })
                .then(response => {
                    this.isResultFound = true
                    this.handleSearchResult(searchQuery, response.data)
                })
                .catch(e => {
                    this.isResultFound = false;
                })
                .finally(() => {
                    this.isSearching = false;
                })
        },
        handleSearchResult(searchQuery: string, responseData: Record<string, any>): void {
            let routeToPush: Object = {}
            switch (responseData.result_type) {
                case 'App\\Models\\Omt\\SalesOrder':
                    this.addToSearchHistory(searchQuery)
                    routeToPush = {
                        name: 'OrderDetailOverview',
                        params: {
                            salesOrderIdentifier: responseData.result_identifier,
                        },
                        hash: (this.hasPermission('orders.dispatchrequests.include.reroutedreplaceddispatchrequests')
                            ? '#include_rerouted_replaced_dispatch_requests=1'
                            : ''
                        ),
                    }
                    break;

                case 'App\\Models\\Omt\\PickupCode':
                    routeToPush = {
                        name: 'OrderDetailPickup',
                        params: {
                            salesOrderIdentifier: responseData.result_identifier,
                        },
                        hash: `#${searchQuery}`
                    }
                    break;
            }

            this.$router.push(
                routeToPush,
                () => this.searchQuery = ''
            )
        },
        clickedOnInput(event: any): void {
            this.searchQuery = '';
            if (this.historyInOverlay) {
                // @ts-ignore
                this.$refs['previousSearches']?.show(event)
            }
        },
        addToSearchHistory(searchQuery: string): void {
            let newHistory: Record<string, any>[] = structuredClone(this.searchHistory)

            const alreadyExistsIndex = newHistory.findIndex((item: Record<string, any>) => item.query === searchQuery)
            if (alreadyExistsIndex !== -1) {
                delete newHistory[alreadyExistsIndex]
            }

            newHistory = newHistory.filter((item: any) => item)
            newHistory.unshift({
                searched_at: Date.now(),
                query: searchQuery,
            });

            localStorage.setItem(CACHE_KEY, JSON.stringify(newHistory));
            this.renewHistory++
        },
        showHistoryDate(timestamp: number) {
            const date = moment(timestamp);
            if (date.isSame(new Date(), 'day')) {
                return date.format('HH:mm')
            }

            return date.format('D MMM')
        },
        getOrderRoute(orderNumber: string) {
            return
        },
        focus() {
            this.$refs['searchInput']?.focus()
        },
    },

    watch: {
        searchQuery(val) {
            this.isResultFound = null;
            this.axiosAbortController.abort()

            if (val.length > 0) {
                if (this.historyInOverlay) {
                    // @ts-ignore
                    this.$refs['previousSearches']?.hide()
                }
                this.debouncedSearch(val);
            }
        },
    }
}
